@if (initialized && dto) {

    <!-- ===================================================================================
         Partner & Berater — the single-page maintenance surface (default section).
         Header: agency entity data. Level 1: partner numbers. Level 2: assignments of the
         selected number. Below both: the agency-wide agents.
         =================================================================================== -->
    @if (activeNavigationItems?.action === cActionAgencyPartners) {
        <div class="p-3">

            <!-- (onLoadData) fires on every (re)load of the header widget, i.e. also after an
                 inline save; the component reloads its own DTO from there so the page title
                 follows the saved name -->
            <div class="mb-3">
                <mvs-widget
                        [widgetData]="generalAgencyWidget"
                        (onLoadData)="handleAgencyDataLoaded()">
                </mvs-widget>
            </div>

            <div class="grid">

                <!-- LEVEL 1 — partner definition (cm.GeneralAgencyNumber), row selectable.
                     A deletion is NOT observed here: a table widget never emits (onChangedObject),
                     it is broadcast on objectChangeEvent — see subscribeToNumberDeletion(). -->
                <div class="col-12 lg:col-5">
                    <mvs-widget
                            [widgetData]="numbersWidget"
                            (onObjectSelect)="handleNumberSelect($event)">
                    </mvs-widget>
                </div>

                <!-- LEVEL 2 — always mounted, only its content is conditional -->
                <div class="col-12 lg:col-7">
                    @if (selectedNumberId) {
                        <div class="mb-3 flex align-items-center gap-2">
                            <i class="fa-regular fa-handshake text-color-secondary"></i>
                            <span class="font-medium">{{ selectedNumberLabel }}</span>
                        </div>

                        <!-- lazy: PrimeNG mounts a panel on its first activation and keeps it
                             mounted afterwards, so switching back does not re-issue the query -->
                        <p-tabs
                                [value]="numberDetailTabIndex"
                                [lazy]="true"
                                (valueChange)="onNumberDetailTabChange($event)">
                            <p-tablist>
                                <p-tab [value]="0">Berater</p-tab>
                                <p-tab [value]="1">Sparten-Einschränkung</p-tab>
                                <p-tab [value]="2">Vertragstyp-Einschränkung</p-tab>
                            </p-tablist>
                            <p-tabpanels>
                                <p-tabpanel [value]="0">
                                    @if (numberAgentsWidget) {
                                        <mvs-widget [widgetData]="numberAgentsWidget"></mvs-widget>
                                    }
                                </p-tabpanel>
                                <p-tabpanel [value]="1">
                                    @if (numberGroupsWidget) {
                                        <mvs-widget [widgetData]="numberGroupsWidget"></mvs-widget>
                                    }
                                </p-tabpanel>
                                <p-tabpanel [value]="2">
                                    @if (numberContractTypesWidget) {
                                        <mvs-widget [widgetData]="numberContractTypesWidget"></mvs-widget>
                                    }
                                </p-tabpanel>
                            </p-tabpanels>
                        </p-tabs>
                    } @else {
                        <div class="p-4 text-center text-color-secondary">
                            Bitte links eine Partnernummer wählen, um Berater und Einschränkungen zu pflegen.
                        </div>
                    }
                </div>

                <!-- Agency-wide, partner independent agent assignments -->
                <div class="col-12">
                    <mvs-widget [widgetData]="agentsWidget"></mvs-widget>
                </div>

            </div>
        </div>
    }

    <!-- ===================================================================================
         Stammdaten — the full metadata-driven entity data form of cm.GeneralAgency.
         =================================================================================== -->
    @if (activeNavigationItems?.action === cActionMasterData) {
        <div class="p-3">
            <mvs-widget
                    [widgetData]="generalAgencyWidget"
                    (onLoadData)="handleAgencyDataLoaded()">
            </mvs-widget>
        </div>
    }

} @else if (loadError) {

    <!-- Load failed: dto and initialized are reset by postRefreshObjectError(), so this is the
         only place that can tell the user what happened. -->
    <div class="p-3">
        <p-message
                severity="error"
                [text]="loadErrorText"
                styleClass="w-full">
        </p-message>
    </div>

} @else {

    <div class="p-3">
        <p-skeleton height="12rem" styleClass="w-full"></p-skeleton>
    </div>

}
